import { Routes } from '@angular/router';

export const companyRoutes: Routes = [
    {
        path: 'companies',
        loadComponent: () => import('./list-companies/list-companies').then(c => c.ListCompanies)
    },
    {
        path: 'companies/:uuid',
        loadComponent: () => import('./company-details/company-details.component').then(c => c.CompanyDetailsComponent)
    }
];
